/* @flow */
import Group from 'entities/Group';
import GroupScheduledMessage from './GroupScheduledMessage.jsx';
import Messages from 'collections/Messages';
import React from 'react';
import cx from 'classnames';

import './styles/GroupScheduledMessageList.scss';

class GroupScheduledMessageList extends React.Component {
  props: {
    messages: Messages,
    group: Group,
    className?: string,
  };

  render() {
    const { messages, className } = this.props;
    const messageList = messages.toArray()
      .sort((a, b) => a.getSendAt() - b.getSendAt())
      .map(message => (
        <GroupScheduledMessage
          className={cx({
            'GroupScheduledMessageList-item': true,
            'GroupScheduledMessageList-non-collapsible-item': true,
          })}
          key={message.get('uuid')}
          message={message}
          group={this.props.group}
        />
      ));

    return (
      <div
        className={cx('GroupScheduledMessageList',
        'GroupScheduledMessageList-non-collapsible', className)}>
        <div key="messageList">
          {messageList}
        </div>
      </div>
    );
  }
}

export default GroupScheduledMessageList;



// WEBPACK FOOTER //
// ./src/groups/components/GroupScheduledMessageList.jsx